import { useQuery } from "helpers/utils";
import { useEffect, useState } from "react";
import MainLayouts from "../../layouts/MainLayouts";
import RegisterDomain from "./RegisterDomain";
import TransferDomain from "./TransferDomain";
// import HostingProductSelector from "./HostingProductSelector";
// import HostingProductSelectorNew from "components/HostingProductSelectorNew";

const DomainOrder = () => {
  const query = useQuery();
  const domainRegister = query.domainregister;
  const domainTransfer = query.domaintransfer;
  const [domainMethod, setDomainMethod] = useState("register");
  const [registrationType, setRegistrationType] = useState("single");
  const [extOption, setExtOption] = useState([]);

  const methodActiveProps = {
    domainMethod,
    setDomainMethod,
    registrationType,
    setRegistrationType,
  };
  
  useEffect(() => {
    if (domainRegister) {
      setDomainMethod("register");
    }
  }, [domainRegister]);

  useEffect(() => {
    if (domainTransfer) {
      setDomainMethod("transfer");
    }
  }, [domainTransfer]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_QWORDS_API}api/domain.php?_type=query`)
      .then((data) => data.json())
      .then((val) => setExtOption(val));
  }, []);

  return (
    <MainLayouts summary={false}>
      <RegisterDomain {...methodActiveProps} extOption={extOption} />
      <TransferDomain {...methodActiveProps} extOption={extOption} />
      {/* <HostingProductSelector /> */}
      {/* <HostingProductSelectorNew /> */}
    </MainLayouts>
  );
};

export default DomainOrder;
